// removed by extract-text-webpack-plugin
module.exports = {"viewerContainer":"RecordingViewers-viewerContainer","pill":"RecordingViewers-pill"};